import React, { Component } from 'react';
import './Confirmation.css';
import { connect } from 'react-redux';
import TextPanel from '../TextPanel/TextPanel';

const mapStateToProps = (state) => ({
  newBookingCode: state.credentials.newBookingCode,
  errMsg: state.credentials.errMsg
});

const mapDispatchToProps = (dispatch) => ({
});

export default connect(mapStateToProps, mapDispatchToProps)(class Confirmation extends Component {

  onReturnClick = () => {

  }

  render() {
    const renderElement = (this.props.newBookingCode !== '') ?
      <TextPanel 
        text={'You have successfully moved your booking!\nPlease check your inbox for your new booking information.'}
        showNewBooking={this.props.newBookingCode}
        showBack={'RESTART'}
        showReturn={'RETURN TO CTRL V'}
        // onReturnClick={this.onReturnClick}
      />
      : 
      <TextPanel 
          text={`An error occurred while moving your booking.\n${this.props.errMsg !== '' ? this.props.errMsg : 'Unknown Error!'}`}
          showNewBooking={this.props.newBookingCode}
          showBack={'TRY AGAIN'}
          // onReturnClick={this.onReturnClick}
        />
      ;
    return (
      <div className={'Confirmation'}>
        {renderElement}
      </div>
    );
  }
});
